import type { AnyValue } from '@mntn-dev/utility-types'

export * from './router-refresh-map.ts'

export type RealtimeEventSchema = Record<string, AnyValue>

export type RealtimeEventType<Schema extends RealtimeEventSchema> = keyof Schema

export type RealtimeSendPayload<
  Schema extends RealtimeEventSchema,
  Type extends RealtimeEventType<Schema>,
> = Schema[Type]

export type RealtimeSendFunction<
  Schema extends RealtimeEventSchema,
  ChannelTypes = string | string[],
> = <Type extends RealtimeEventType<Schema>>(
  channels: ChannelTypes,
  type: Type,
  payload: RealtimeSendPayload<Schema, Type>
) => Promise<number>

export type RealtimeHandlerData<
  Schema extends RealtimeEventSchema,
  Type extends RealtimeEventType<Schema>,
> = { data: Schema[Type]; name: Type }

export type RealtimeSubscribeFunction<
  Schema extends RealtimeEventSchema,
  Type extends RealtimeEventType<Schema>,
> = (message: RealtimeHandlerData<Schema, Type>) => Promise<void>

export type RealtimeMessageHandlerFunction<Schema extends RealtimeEventSchema> =
  <T extends RealtimeEventType<Schema>>(
    message: RealtimeHandlerData<Schema, T>
  ) => void | Promise<void>

export * from './channel-name.ts'
